import { render, staticRenderFns } from "./ChatInfoProfile.vue?vue&type=template&id=e3ec65c2&"
import script from "./ChatInfoProfile.vue?vue&type=script&lang=js&"
export * from "./ChatInfoProfile.vue?vue&type=script&lang=js&"
import style0 from "./ChatInfoProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports